import React from 'react';

import EntityForm from 'components/EntityPage/EntityForm';
import CONSTANTS from 'utils/constants';
import userSchema from '../schema';

const UserForm = ({
  isEditing,
  isProfile,
  isCreating,
  entity,
  entityInfos,
  onSubmitHandler,
}) => {
  const entityInfosWithScreen = {
    ...entityInfos,
    i18nScreenName: 'UserForm',
  };
  /**
   * Add inputs for role
   */
  const { USERS_ROLES, USERS_ROLES_AS_STRING } = CONSTANTS;
  const roleForInputs = USERS_ROLES.map((role) => {
    const label = USERS_ROLES_AS_STRING[role];
    return { value: role, label };
  });
  const entityOptions = {
    role: roleForInputs,
  };

  return (
    <EntityForm
      isProfile={isProfile}
      isEditing={isEditing}
      isCreating={isCreating}
      entity={entity}
      entityInfos={entityInfosWithScreen}
      onSubmitHandler={onSubmitHandler}
      schema={userSchema}
      options={entityOptions}

      // entity={entity}
      // entityInfos={entityInfos}
      // entitySchema={userSchema}
      // onActivityLogSubmitHandler={onActivityLogSubmitHandler}
    />
  );
};

export default UserForm;
